import { cn } from '../../utils/cn';
import {
  Select,
  SelectContent,
  // SelectGroup,
  SelectItem,
  SelectLabel,
  SelectTrigger,
  SelectValue,
} from '../../utils/components/ui/select';
import { ReactNode } from 'react';

export type OptionsType = {
  id?: number | string | boolean;
  name: string;
};
interface SelectDropDownProps {
  options: OptionsType[] | undefined;
  placeholder?: ReactNode;
  label?: string;
  className?: string;
  value?: string | null; // Value of the selected option
  onChange?: (value: string) => void; // Function to call when the selected option changes
}

export default function DropDownComponent({
  options,
  placeholder,
  label,
  className,
  value,
  onChange,
}: SelectDropDownProps) {
  return (
    <Select
      onValueChange={onChange}
      defaultValue={String(value ?? '')}
      disabled={!options?.length}
    >
      <SelectTrigger
        className={cn(
          'w-fit border-[#ADE7DE]  font-medium',
          className
        )}
      >
        <SelectValue placeholder={placeholder} />
      </SelectTrigger>
      <SelectContent className="z-[100] bg-white">
        <>
          {label && <SelectLabel>{label}</SelectLabel>}
          {options?.map(option => (
            <SelectItem
              key={option.id + ''}
              value={String(option.id)}
              className=""
            >
              {option.name}
            </SelectItem>
          ))}
        </>
      </SelectContent>
    </Select>
  );
}
